export const Blogs = [] 